import React, { useState, useContext, useEffect, useMemo } from "react";
import {
  Button,
  Grid,
  makeStyles,
  IconButton,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Typography,
  TextField as MaterialTexfield,
  useTheme,
  Input,
  FormHelperText,
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import CloseIcon from "@material-ui/icons/Close";
import { productsServices } from "../services";
import { AuthContext } from "../context";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ModalBase, TextField } from "./";
import { laboratoryServices } from "../services";

import RichTextEditor from "react-rte";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// export default function AddProduct(props) {
export default function EditProduct(props) {
  // console.log("props: ", props);
  const theme = useTheme();

  const { product, specialtiesList } = props;
  const classes = useStyles();
  const [fileUpload, setFileUpload] = useState(null);
  //const [productName, setProductName] = useState(null);
  const { authState } = useContext(AuthContext);
  const {
    user: {
      role: { name: roleName },
    },
  } = authState;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    ...rest
  } = useForm();
  const isMasterAdmin = authState.user.role._id === "5fdb9e3db3bfce86908e440f";
  const isAdmin = roleName === "LABORATORY_ADMIN";
  const [previewImage, setPreviewImage] = useState(product.logo);
  const [specialties, setSpecialties] = useState(product.specialties);
  const [previewDoc, setPreviwDoc] = useState(product.clinicalStudies);
  const [newClinicalStudies, setNewClinicalStudies] = useState([]);
  const [name, setName] = useState(product.name);
  const [molecule, setMolecule] = useState(product.molecule);
  const [indications, setIndications] = useState(product.indications);
  const [presentation, setPresentation] = useState(product.presentation);
  const [concentration, setConcentration] = useState(product.concentration);
  const [isp, setIsp] = useState(product.isp);
  const [validity, setValidity] = useState(product.validity);
  const [price, setPrice] = useState(product.price);
  const [state, setState] = useState(product.status);
  const [productStatuses, setProductStatuses] = useState([]);
  const [childLaboratories, setChildLaboratories] = useState([]);
  const [availableSpecialties, setAvailableSpecialties] = useState(
    product.laboratory.specialties
  );
  //prospecto
  const [bula, setBula] = useState(product.bula);
  const [contraIndications, setContraIndications] = useState(
    product.contraIndications
  );
  const [richTextPrograms, setRichTextPrograms] = useState(
    product.richTextPrograms
  );
  const [labId, setLabId] = useState(product.laboratory._id);

  useEffect(() => {
    async function init() {
      try {
        const { status, response } =
          await laboratoryServices.getChildLaboratories({
            laboratoryId: product.laboratory.parentLaboratory._id,
            token: authState.token,
            text: "",
          });
        if (status === 200) {
          setChildLaboratories(response.laboratories);
        }
      } catch (error) {
        console.error("Error during initialization:", error);
      }
    }
    if (isMasterAdmin) {
      init();
    } else setChildLaboratories(props.childLaboratories);
  }, []);
  useEffect(() => {
    const getAllProductStatus = async () => {
      try {
        const response = await productsServices.getAllProductStatus({
          token: authState.token,
        });
        setProductStatuses(response.data);
      } catch (error) {
        console.error("Error al obtener los estados de las ordenes:", error);
      }
    };
    getAllProductStatus();
  }, []);

  useEffect(() => {
    const changeAvailableSpecialties = () => {
      setAvailableSpecialties(() => {
        const foundChildLab = childLaboratories?.find(
          ({ _id }) => _id === labId
        );
        return foundChildLab?.specialties || product.laboratory.specialties;
      });
    };
    if (isAdmin || isMasterAdmin) changeAvailableSpecialties();
  }, [labId]);
  // console.log({authState}, {product}, { props });

  // const availableSpecialties = useMemo(() => {
  //   if (isMasterAdmin)
  //     return props.product.laboratory.parentLaboratory.specialties;
  //   else
  //     return specialtiesList.filter((specialty) =>
  //       authState.user.laboratory.specialties.find(
  //         (obj) => obj._id === specialty._id
  //       )
  //     );
  // }, []);

  // useEffect(()=>{
  // 	console.log("Cambios", indications, contraIndications)
  // },[indications, contraIndications])

  // useEffect(() => {
  //   async function init() {
  //     try {
  //       //console.log({product})
  //       setPreviewImage(product.logo);
  //       setPreviwDoc(product.clinicalStudies);
  //       setLabId(product.laboratory._id);

  //       let specialtiesAux = [];
  //       specialtiesList.forEach((element) => {
  //         if (
  //           product.specialties.find((value) => value.name === element.name)
  //         ) {
  //           specialtiesAux.push(element);
  //         }
  //       });
  //       setSpecialties(specialtiesAux);
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   }
  //   init();
  // }, [product, specialtiesList]);

  useEffect(() => {
    async function init() {
      try {
        const { status, response } =
          await laboratoryServices.getChildLaboratories({
            laboratoryId: product.laboratory.parentLaboratory._id,
            token: authState.token,
            text: "",
          });
        if (status === 200) {
          setChildLaboratories(response.laboratories);
        }
      } catch (error) {
        console.error("Error during initialization:", error);
      }
    }
    if (authState.user.role._id === "5fdb9e3db3bfce86908e440f") {
      init();
    } else setChildLaboratories(props.childLaboratories);
  }, []);
  const handleChange = async (e) => {
    setPreviewImage(URL.createObjectURL(e.target.files[0]));
    setFileUpload(e.target.files[0]);
  };

  const handleChangeStudies = async (e) => {
    let docs = [...e.target.files];
    //console.log({docs})
    setNewClinicalStudies(docs);
  };

  // useEffect(() => {
  //   console.log("Valido", validity);
  // }, []);
  const [loading, setLoading] = useState(false);

  const saveProduct = async (dataToInsert) => {
    // console.log("prospecto", dataToInsert.bula);
    let formData = new FormData();
    formData.append("name", dataToInsert.name);
    formData.append("molecule", dataToInsert.molecule);
    formData.append("indications", indications);
    formData.append("presentation", dataToInsert.presentation);
    formData.append("concentration", dataToInsert.concentration);
    formData.append("isp", dataToInsert.isp);
    formData.append("price", dataToInsert.price);
    //prospecto
    // formData.append("bula", dataToInsert.bula);
    const laboratoryId =
      isAdmin || isMasterAdmin ? labId : authState.user.laboratory._id;

    formData.append("laboratoryId", laboratoryId);
    // formData.append("validity", dataToInsert.validity);
    formData.append(
      "logo",
      fileUpload ? fileUpload : JSON.stringify({ logo: product.logo })
    );
    formData.append("contraIndications", contraIndications);
    formData.append("specialties", JSON.stringify(specialties));
    formData.append("clinicalStudies", JSON.stringify(previewDoc));
    if (newClinicalStudies.length) {
      newClinicalStudies.forEach((doc) =>
        formData.append("newClinicalStudies", doc)
      );
    }
    // richTextPrograms
    formData.append(
      "richTextPrograms",
      JSON.stringify({ text: richTextPrograms })
    );

    formData.append("productStatus", state);

    try {
      setLoading(true);
      const { status, response } = await productsServices.updateProduct({
        formData,
        token: authState.token,
        productId: product._id,
      });
      switch (status) {
        case 201:
          props.reload();
          props.toast(response.message, true);
          props.close();
          break;
        case 200:
          props.toast(response.message, true);
          props.close();
          break;
        default:
          break;
      }
      if (response.error) {
        props.toast(response.error.message, true);
      }
      props?.refetch && props?.refetch();
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const onDeleteClinicalStudy = (url) => {
    let docs = previewDoc.filter((doc) => url !== doc.url);
    setPreviwDoc(docs);
  };

  const onDeleteNewClinicalStudy = (name) => {
    let docs = newClinicalStudies.filter((doc) => name !== doc.name);
    setNewClinicalStudies(docs);
  };

  const [richText, setRichText] = useState(
    RichTextEditor.createValueFromString(richTextPrograms || " ", "html")
  );
  const [openRichText, setOpenRichText] = useState(false);

  const [richTextP, setRichTextP] = useState(
    RichTextEditor.createValueFromString(richTextPrograms || " ", "html")
  );
  const [openRichTextP, setOpenRichTextP] = useState(false);

  const [richTextC, setRichTextC] = useState(
    RichTextEditor.createValueFromString(contraIndications || " ", "html")
  );
  const [openRichTextC, setOpenRichTextC] = useState(false);

  return (
    <ModalBase open={props.open} close={props.close} title="Editar producto">
      <form className={classes.form} onSubmit={handleSubmit(saveProduct)}>
        <Grid container spacing={2}>
          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              label="Nombre"
              placeholder="Nombre"
              name="name"
              autoComplete="name"
              size="small"
              inputRef={register({
                required: "Nombre requerido",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.name ? true : false}
              helperText={errors.name ? errors.name.message : ""}
            />
          </Grid>
          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="molecule"
              value={molecule}
              onChange={(e) => setMolecule(e.target.value)}
              label="Molécula"
              name="molecule"
              placeholder="Molécula"
              autoComplete="molecule"
              size="small"
              inputRef={register({
                required: "Molécula requerida",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.molecule ? true : false}
              helperText={errors.molecule ? errors.molecule.message : ""}
            />
          </Grid>

          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="presentation"
              label="Presentación"
              value={presentation}
              onChange={(e) => setPresentation(e.target.value)}
              name="presentation"
              placeholder="Presentación"
              autoComplete="presentation"
              size="small"
              inputRef={register({
                required: "Presentación requerida",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.presentation ? true : false}
              helperText={
                errors.presentation ? errors.presentation.message : ""
              }
            />
          </Grid>
          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="concentration"
              label="Concentración"
              value={concentration}
              onChange={(e) => setConcentration(e.target.value)}
              name="concentration"
              placeholder="Concentración"
              autoComplete="concentration"
              size="small"
              inputRef={register({
                required: "Concentración requerida",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.presentations ? true : false}
              helperText={
                errors.presentations ? errors.presentations.message : ""
              }
            />
          </Grid>
          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="isp"
              label="ISP"
              value={isp}
              onChange={(e) => setIsp(e.target.value)}
              name="isp"
              placeholder="ISP"
              autoComplete="isp"
              size="small"
              inputRef={register({
                required: "ISP requerido",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.isp ? true : false}
              helperText={errors.isp ? errors.isp.message : ""}
            />
          </Grid>
          {/* <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="validity"
              label="Vigencia"
              value={validity}
              onChange={(e) => setValidity(e.target.value)}
              name="validity"
              placeholder="Vigencia"
              type="date"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register({
                required: "Validez requerida",
              })}
            />
          </Grid> */}
          <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="price"
              label="Precio referencial"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              name="price"
              placeholder="Precio referencial"
              type="string"
              autoComplete="price"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
            />
          </Grid>

          {/* Prospecto		 */}
          {/* <Grid item lg={6} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="bula"
              label="Prospecto"
              value={bula}
              onChange={(e) => setBula(e.target.value)}
              name="bula"
              placeholder="Prospecto"
              autoComplete="bula"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              inputRef={register}
            />
          </Grid> */}

          {(isAdmin || isMasterAdmin) && (
            <Grid item lg={12} xs={12} sm={12}>
              <FormControl
                variant="outlined"
                className={`${classes.formControl}  ${classes.shrinkLabel}`}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  Unidad de negocio
                </InputLabel>
                <Select
                  labelId="demo-mutiple-name-label"
                  id="demo-mutiple-name"
                  label="Unidad de negocio"
                  placeholder="Unidad de negocio"
                  value={labId}
                  onChange={(e) => setLabId(e.target.value)}
                  MenuProps={MenuProps}
                  className={classes.select}
                >
                  {childLaboratories.map((element, index) => (
                    <MenuItem key={index} value={element._id}>
                      {element.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item lg={12} xs={12} sm={12}>
            <FormControl
              variant="outlined"
              className={`${classes.formControl}  ${classes.shrinkLabel}`}
            >
              <Autocomplete
                multiple
                id="especialidades"
                options={availableSpecialties}
                getOptionLabel={(option) => option.name}
                filterSelectedOptions
                variant="outlined"
                label="Especialidades"
                value={specialties}
                getOptionSelected={(option, value) => option._id === value?._id}
                onChange={(event, newValue) => {
                  setSpecialties(newValue);
                }}
                renderInput={(params) => (
                  <MaterialTexfield
                    {...params}
                    id="especialidades"
                    name="especialidades"
                    placeholder="Especialidades"
                    variant="outlined"
                    label="Especialidades"
                  />
                )}
              />
            </FormControl>
          </Grid>

          {/* <Grid item lg={12} xs={12} sm={12}>
            <FormControl fullWidth>
              <InputLabel htmlFor="orders-status-select">
                Estado del producto
              </InputLabel>
              <Select
                native
                value={state}
                onChange={(e) => setState(e.target.value)}
                inputProps={{
                  name: "status",
                  id: "orders-status-select",
                }}
              >
                <option aria-label="None" value="" />
                {productStatuses.map((status) => (
                  <option key={status._id} value={status._id}>
                    {status.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid> */}

          <Grid item lg={12} xs={12} sm={12}>
            <FormControl
              variant="outlined"
              className={`${classes.formControl}  ${classes.shrinkLabel}`}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                Estado del producto
              </InputLabel>
              <Select
                labelId="demo-mutiple-name-label"
                id="demo-mutiple-name"
                label="Estado del producto"
                placeholder="Estado del producto"
                value={state}
                onChange={(e) => {
                  setState(e.target.value);
                  setValue("state", e.target.value);
                }}
                MenuProps={MenuProps}
                className={classes.select}
              >
                {productStatuses.map((status) => (
                  <MenuItem key={status._id} value={status._id}>
                    {status.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item lg={12} xs={12} sm={12}>
            <TextField
              variant="outlined"
              fullWidth
              id="indications"
              label="Indicaciones"
              value={indications}
              onChange={(e) => setIndications(e.target.value)}
              name="indications"
              placeholder="Indicaciones"
              autoComplete="indications"
              multiline
              rows={3}
              size="small"
              inputRef={register({
                required: "Indicaciones requerida",
              })}
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.indications ? true : false}
              helperText={errors.indications ? errors.indications.message : ""}
            />
          </Grid>
          <Grid item lg={12} xs={12} sm={12}>
            {/* <TextField
              variant="outlined"
              fullWidth
              id="contraIndications"
              multiline
              rows={3}
              label="Contraindicaciones"
              placeholder="Contraindicaciones"
              name="contraIndications"
              autoComplete="contraIndications"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => setContraIndi(e.target.value)}
            /> */}

            <FormControl style={{ display: "flex" }}>
              <InputLabel
                htmlFor="rich-text"
                style={{ color: theme.palette.primary.main }}
              >
                Contraindicaciones
              </InputLabel>
              {/* 
              <Input
                id="rich-text"
                aria-describedby="helper-rich-text"
                disableUnderline
                name="contraIndications"
                inputComponent={() => (
                  
                )}
              /> */}
              <RichTextEditor
                toolbarConfig={{
                  display: ["LINK_BUTTONS", "INLINE_STYLE_BUTTONS"],
                  INLINE_STYLE_BUTTONS: [
                    {
                      label: "Bold",
                      style: "BOLD",
                      className: "custom-css-class",
                    },
                    { label: "Italic", style: "ITALIC" },
                    { label: "Underline", style: "UNDERLINE" },
                  ],
                }}
                rootStyle={{
                  innerWidth: "100%",
                  outerWidth: "100%",
                  width: "100%",
                  fontFamily: "Arial",
                  margin: "3rem 0 0 0",
                  zIndex: "999",
                }}
                id="rich-text"
                readOnly={!openRichTextC}
                value={richTextC}
                onChange={(rtext) => {
                  setRichTextC(rtext);
                  setValue("contraIndications", rtext.toString("html"));
                  setContraIndications(rtext.toString("html"));
                }}
              />
              <FormHelperText
                id="my-helper-text"
                error={Boolean(errors.contraIndications)}
                helperText={
                  errors.contraIndications
                    ? errors.contraIndications.message
                    : " "
                }
              />
              <Button
                fullWidth
                component="label"
                color="primary"
                variant="outlined"
                style={{ borderRadius: 25 }}
                onClick={() => {
                  setOpenRichTextC(!openRichTextC);
                }}
              >
                {openRichTextC ? "Cerrar Editor" : "Agregar Contraindicaciones"}
              </Button>
            </FormControl>
          </Grid>
          <Grid item lg={12} xs={12} sm={12}>
            <FormControl style={{ display: "flex" }}>
              <InputLabel
                htmlFor="rich-text"
                style={{ color: theme.palette.primary.main }}
              >
                Programas
              </InputLabel>

              {/* <Input
                id="rich-text"
                aria-describedby="helper-rich-text"
                disableUnderline
                name="programs"
                // inputRef={register({
                //                // required: "Programas requerido",
                //              })}
                inputComponent={() => (
                  )}
              /> */}
              <RichTextEditor
                toolbarConfig={{
                  display: ["LINK_BUTTONS", "INLINE_STYLE_BUTTONS"],
                  INLINE_STYLE_BUTTONS: [
                    {
                      label: "Bold",
                      style: "BOLD",
                      className: "custom-css-class",
                    },
                    { label: "Italic", style: "ITALIC" },
                    { label: "Underline", style: "UNDERLINE" },
                  ],
                }}
                rootStyle={{
                  innerWidth: "100%",
                  outerWidth: "100%",
                  width: "100%",
                  fontFamily: "Arial",
                  margin: "3rem 0 0 0",
                }}
                id="rich-text"
                readOnly={!openRichTextP}
                value={richTextP}
                onChange={(rtext) => {
                  setRichTextP(rtext);
                  setValue("programs", rtext.toString("html"));
                  setRichTextPrograms(rtext.toString("html"));
                }}
              />

              <FormHelperText
                id="my-helper-text"
                error={Boolean(errors.programs)}
                helperText={errors.programs ? errors.programs.message : " "}
              />
              <Button
                fullWidth
                component="label"
                color="primary"
                variant="outlined"
                style={{ borderRadius: 25 }}
                onClick={() => {
                  setOpenRichTextP(!openRichTextP);
                }}
              >
                {openRichTextP ? "Cerrar Editor" : "Agregar Programas"}
              </Button>
            </FormControl>
          </Grid>
          <Grid item lg={6} xs={12} sm={12}>
            <Button
              fullWidth
              style={{ borderRadius: 25 }}
              component="label"
              color="primary"
              variant="outlined"
            >
              Cambiar Logo
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleChange}
              />
            </Button>
            {previewImage && (
              <div style={{ textAlign: "center", marginTop: 12 }}>
                <img
                  alt=""
                  src={previewImage}
                  style={{ objectFit: "cover", width: "100px", height: "100px", borderRadius: 8 }}
                />
              </div>
            )}
          </Grid>
          <Grid item lg={6} xs={12} sm={12}>
            <Button
              fullWidth
              style={{ borderRadius: 25 }}
              component="label"
              color="primary"
              variant="outlined"
            >
              Agregar Estudios Clinicos
              <input
                type="file"
                accept="application/pdf,application/vnd.ms-excel"
                multiple
                hidden
                onChange={handleChangeStudies}
              />
            </Button>
          </Grid>
          {previewDoc.map((doc, index) => (
            <Grid
              item
              lg={12}
              xs={12}
              sm={12}
              style={{ textAlign: "center", position: "relative" }}
              key={index}
            >
              <IconButton
                title="Eliminar"
                aria-label="Eliminar"
                className={classes.closeButton}
                onClick={() => onDeleteClinicalStudy(doc.url)}
              >
                <CloseIcon />
              </IconButton>
              <InsertDriveFileIcon
                fontSize="large"
                style={{ color: "#2196C0" }}
              />
              <Typography>{doc.name}</Typography>
            </Grid>
          ))}
          {newClinicalStudies.map((doc, index) => (
            <Grid
              item
              lg={12}
              xs={12}
              sm={12}
              style={{ textAlign: "center", position: "relative" }}
              key={index}
            >
              <IconButton
                title="Eliminar"
                aria-label="Eliminar"
                className={classes.closeButton}
                onClick={() => onDeleteNewClinicalStudy(doc.name)}
              >
                <CloseIcon />
              </IconButton>
              <InsertDriveFileIcon
                fontSize="large"
                style={{ color: "#2196C0" }}
              />
              <Typography>{doc.name}</Typography>
            </Grid>
          ))}
        </Grid>
        <Button
          type="submit"
          fullWidth
          size="small"
          variant="contained"
          color="primary"
          className={classes.submit}
          disabled={loading}
          style={{ textTransform: "capitalize", borderRadius: "20px" }}
        >
          {!loading ? "Editar Productos" : "Cargando"}
        </Button>
      </form>
    </ModalBase>
  );
}

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    width: "100%",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#f44336",
  },
  dialogTitle: {
    textAlign: "Center",
  },
  formControl: {
    width: "100%",
    minWidth: 120,
    "& div": {
      borderRadius: 25,
    },
  },
  select: {
    "& > div:nth-child(1)": {
      padding: "10.5px 14px",
    },
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  shrinkLabel: {
    "& > label:nth-child(1)": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
    "& > div:nth-child(2)": {
      "& > fieldset": {
        "& > legend": {
          maxWidth: 1000,
        },
      },
    },
  },
}));
